var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import StyledButton from '@kiwicom/orbit-components/lib/Button';
export var tuple = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args;
};
var _Button = /** @class */ (function (_super) {
    __extends(_Button, _super);
    function _Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Button.prototype.render = function () {
        switch (this.props.type) {
            default: {
                var Button_1 = styled(StyledButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          ", "\n          &:focus {\n            outline: none;\n          }\n        "], ["\n          ", "\n          &:focus {\n            outline: none;\n          }\n        "])), this.props.style);
                return (_jsx(Button_1, __assign({ size: this.props.size, iconRight: this.props.iconRight, iconLeft: this.props.iconLeft, bordered: this.props.ghost, fullWidth: this.props.block, loading: this.props.loading, disabled: this.props.disable, onClick: this.props.onClick }, { children: this.props.children })));
            }
        }
    };
    return _Button;
}(React.PureComponent));
export { _Button };
var ButtonColor = tuple('primary', 'danger', 'action', 'smoke', 'secondary');
var ButtonSize = tuple('normal', 'small', 'large');
export var Button = function (props) {
    var buttonProps = {
        type: props.type ? props.type : 'primary',
        ghost: props.ghost,
        iconLeft: props.iconLeft,
        iconRight: props.iconRight,
        block: props.block,
        children: props.children,
        onClick: props.onClick,
        disable: props.disable,
        label: props.label,
        size: props.size,
        loading: props.loading,
    };
    buttonProps.style = __assign(__assign({}, buttonProps.style), {
        backgroundColor: '#00F0AA',
        borderRadius: 5,
        marginLeft: props.marginLeft ? 8 : 0,
    });
    if (!props.ghost) {
        if (props.type === 'danger') {
            buttonProps.style = __assign(__assign({}, buttonProps.style), {
                backgroundColor: '#EB5757',
            });
        }
        if (props.type === 'action') {
            buttonProps.style = __assign(__assign({}, buttonProps.style), {
                backgroundColor: '#07285B',
            });
        }
        if (props.type === 'smoke') {
            buttonProps.style = __assign(__assign({}, buttonProps.style), {
                backgroundColor: '#979797',
            });
        }
    }
    else {
        buttonProps.style = __assign(__assign({}, buttonProps.style), {
            backgroundColor: 'transparent',
        });
        if (props.type === 'danger') {
            buttonProps.style = __assign(__assign({}, buttonProps.style), {
                boxShadow: 'inset 0 0 0 1px #EB5757',
                color: '#EB5757 !important',
            });
        }
        if (props.type === 'action') {
            buttonProps.style = __assign(__assign({}, buttonProps.style), {
                boxShadow: 'inset 0 0 0 1px #07285B',
                color: '#07285B !important',
            });
        }
        if (props.type === 'smoke') {
            buttonProps.style = __assign(__assign({}, buttonProps.style), {
                boxShadow: 'inset 0 0 0 1px #979797',
                color: '#979797 !important',
            });
        }
    }
    if (props.style) {
        Object.assign(buttonProps.style, props.style);
    }
    if (props.color) {
        buttonProps.style.backgroundColor = props.color;
    }
    if (props.width) {
        buttonProps.style.width = props.width;
    }
    // eslint-disable-next-line react/jsx-pascal-case
    return _jsx(_Button, __assign({}, buttonProps));
};
var templateObject_1;
